export default __webpack_public_path__ + "static/media/banner.4d8fce34.png";